import { showMobileError } from '@/mobile-ui';
import { type ErrorTip, ErrorTipMode } from '@ts-max/axios';
import { t } from 'i18next';
import { isValidElement, type ReactNode } from 'react';

export function showError(options: ErrorTip | string | ReactNode | Error) {
  if (!options) return;

  let title = t('common:error');
  let mode = ErrorTipMode.message;
  let message: ReactNode | string | undefined;

  if (typeof options === 'string') {
    message = options;
  }

  if (isValidElement(options)) {
    message = options;
  }

  if (options instanceof Error) {
    message = options.message;
  }

  if (
    typeof options === 'object' &&
    !isValidElement(options) &&
    !(options instanceof Error)
  ) {
    title = (options as ErrorTip).title || title;
    mode = (options as ErrorTip).mode || mode;
    message = (options as ErrorTip).content;
  }

  if (!message) return;

  showMobileError({ content: message, mode, title });
}
